define((require) => {
    "use strict";

    var ButtonWidgetModel = require("shared/ui/experience/widgets/button/ButtonWidgetModel");

    /**
     * @class {ButtonWidgetModelEditorMixin}
     *
     * Extra classes used by the editor, but not needed by the viewer.
     */
    return ButtonWidgetModel.mixin("ButtonWidgetModelEditorMixin", {
        /**
         * Returns self description string
         *
         * @return {string|null} The self description
         */
        _getSelfDescription: function() {
            return this.get("label")
                ? `Button: ${this.get("label")}`
                : null;
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/button/ButtonWidgetModelEditorMixin.js